import { useState } from "react";
import { useTheme } from "../context/ThemeContext";

export default function DeleteConfirm({ id, label, onConfirm, onClose }) {
  const { mode } = useTheme();
  const [confirming, setConfirming] = useState(false);

  const handleConfirm = async () => {
    setConfirming(true);
    try {
      await onConfirm(id);
    } finally {
      setConfirming(false);
    }
  };

  return (
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.35)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:400, fontFamily:"'DM Sans', system-ui, sans-serif" }}
    >
      <div style={{ background:"var(--surface)", border:`1px solid var(--border)`, borderRadius:10, padding:"26px 28px", width:360, boxShadow:"0 4px 24px rgba(0,0,0,0.12)" }}>

        <div style={{ width:40, height:40, borderRadius:"50%", background:"var(--amber-bg)", border:`1px solid var(--amber-border)`, display:"flex", alignItems:"center", justifyContent:"center", marginBottom:16, fontSize:18 }}>
          ⚠
        </div>

        <div style={{ fontSize:15, fontWeight:700, color:"var(--ink)", marginBottom:8 }}>
          Archive {label}?
        </div>

        <div style={{ fontSize:12, color:"var(--text-sub)", lineHeight:1.65, marginBottom:22 }}>
          <span style={{ fontFamily:"'IBM Plex Mono', monospace", fontWeight:600, color:"var(--ink)" }}>{id}</span> will
          be marked as <strong>archived</strong> and hidden from active lists.
          No data will be deleted — this can be reversed by editing the status.
        </div>

        <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
          <button
            onClick={onClose}
            style={{ background:"var(--surface)", border:`1px solid var(--border)`, borderRadius:6, padding:"7px 16px", fontSize:12, color:"var(--text)", cursor:"pointer", fontFamily:"inherit" }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={confirming}
            style={{ background:"var(--amber)", border:"none", borderRadius:6, padding:"7px 20px", fontSize:12, fontWeight:600, color:"#fff", cursor: confirming ? "not-allowed" : "pointer", opacity: confirming ? 0.7 : 1, fontFamily:"inherit" }}
          >
            {confirming ? "Archiving…" : "Archive"}
          </button>
        </div>
      </div>
    </div>
  );
}
